import React from 'react';

function Contact() {
  return (
    <div className="contact-page">
      <h1 className="text-center mt-5">Contact Us</h1>
      <div
        className="container py-5 d-flex align-items-center gap-5"
      >
        {/* Contact Information Card */}
        <div className="row justify-content-center w-100">
          <div className="col-md-8 col-lg-12">
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <h2 className="card-title">Contact Information</h2>
                <p><strong>Address:</strong></p>
                <address>
                  A.C.SUBBA REDDY<br />
                  GOVERNMENT MEDICAL COLLEGE<br />
                  Government Medical Hospital Campus<br />
                  Nellore, Andhra Pradesh 524004
                </address>

                <p className="mt-3"><strong>Email:</strong></p>
                <p>
                  <i className="fas fa-envelope me-2 text-primary"></i>
                  info@acsrgmc.edu.in
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Google Map Embed */}
        <div className="w-100">
          <div className="ratio ratio-16x9">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6021.403167565305!2d79.95882910602519!3d14.426452124070433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4cf2dfad7a77cb%3A0x8db936f853730b70!2sAC%20SUBBA%20REDDY%20GOVT%20MEDICAL%20COLLEGE!5e0!3m2!1sen!2sin!4v1753977775406!5m2!1sen!2sin"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="College Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
